/* BAHÍA 82 · Búsqueda por referencias olfativas (Taste). */
(() => {
  'use strict';
  const node = document.getElementById('b82-reference-index');
  if (!node) return;
  let products = [];
  try {
    products = JSON.parse(node.textContent || '[]').filter((x) => x && x.url && x.reference && x.title);
  } catch (error) {
    console.warn('BAHÍA 82: no se pudo leer el índice olfativo.', error);
    return;
  }
  if (!products.length) return;

  const normalize = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[’‘\u2019]/g, "'")
    .toLocaleLowerCase('es').replace(/\s+/g, ' ').trim();

  function findMatches(raw) {
    const query = normalize(raw);
    if (query.length < 2) return [];
    const words = query.split(' ').filter(Boolean);
    const ranked = products.map((item) => {
      const reference = normalize(item.reference);
      const title = normalize(item.title);
      const keywords = normalize(item.keywords);
      const matchesAll = (text) => text.includes(query) || words.every((word) => text.includes(word));
      let score = 0;
      if (reference === query || title === query) score = 5;
      else if (matchesAll(reference)) score = 4;
      else if (matchesAll(title)) score = 3;
      else if (matchesAll(keywords)) score = 1;
      return { item, score };
    }).filter((x) => x.score > 0);
    return ranked.sort((a, b) => b.score - a.score).slice(0, 12).map((x) => x.item);
  }

  function matchKey(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (_) { return url; }
  }

  function makeImg(product) {
    if (!product.image) return null;
    const image = document.createElement('img');
    image.src = product.image;
    image.alt = product.title;
    image.loading = 'lazy';
    image.width = 65;
    image.height = 65;
    return image;
  }

  function buildSuggestion(item, index) {
    const li = document.createElement('li');
    li.className = 'predictive-search__list-item b82-reference-prediction';
    li.id = 'b82-reference-option-' + index;
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    const link = document.createElement('a');
    link.href = item.url;
    link.tabIndex = 0;
    link.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
    const img = makeImg(item);
    if (img) { img.className = 'predictive-search__image'; link.append(img); }
    const info = document.createElement('div');
    info.className = 'predictive-search__item-content';
    const title = document.createElement('p');
    title.className = 'predictive-search__item-heading h5';
    title.textContent = item.title;
    const ref = document.createElement('span');
    ref.className = 'b82-reference-subtitle';
    ref.textContent = 'Referencia olfativa: ' + item.reference;
    const price = document.createElement('span');
    price.className = 'b82-reference-price';
    price.textContent = item.price;
    info.append(title, ref, price);
    link.append(info);
    li.append(link);
    return li;
  }

  function decoratePredictive(host) {
    const region = host.querySelector('[data-predictive-search]');
    const container = region?.querySelector('#predictive-search-results');
    if (!container) return;
    // Solo después de que Shopify haya renderizado su respuesta.
    if (!container.querySelector('#predictive-search-option-search-keywords')) return;
    const query = host.querySelector('input[type="search"]')?.value || '';
    const normalizedQuery = normalize(query);
    const existing = container.querySelector('.b82-reference-group');
    // Evitar que MutationObserver reprocesse nuestra propia inserción sin fin.
    if (existing && existing.dataset.b82Query === normalizedQuery) return;
    existing?.remove();
    const matches = findMatches(query);
    if (!matches.length) return;
    const alreadyShown = new Set(Array.from(container.querySelectorAll('a[href]')).map(a => matchKey(a.getAttribute('href'))));
    const additional = matches.filter(x => !alreadyShown.has(matchKey(x.url)));
    if (!additional.length) return;
    const group = document.createElement('div');
    group.className = 'b82-reference-group';
    group.dataset.b82Query = normalizedQuery;
    const heading = document.createElement('h2');
    heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    heading.textContent = 'Perfumes para tu búsqueda';
    const list = document.createElement('ul');
    list.className = 'predictive-search__results-list list-unstyled';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', 'Perfumes por referencia olfativa');
    additional.forEach((item, i) => list.append(buildSuggestion(item, i)));
    group.append(heading, list);
    const searchAll = container.querySelector('#predictive-search-option-search-keywords');
    searchAll.before(group);
    const counter = container.querySelector('[data-total-results]');
    if (counter) {
      const nativeCount = Number(counter.getAttribute('data-total-results')) || 0;
      counter.setAttribute('data-total-results', String(nativeCount + additional.length));
      counter.textContent = (nativeCount + additional.length) + ' resultados disponibles';
    }
  }

  function initPredictive() {
    document.querySelectorAll('predictive-search').forEach((host) => {
      if (host.dataset.b82ReferenceReady) return;
      const region = host.querySelector('[data-predictive-search]');
      if (!region) return;
      host.dataset.b82ReferenceReady = 'true';
      const observer = new MutationObserver(() => decoratePredictive(host));
      // Shopify sustituye los hijos de region al actualizar sugerencias.
      observer.observe(region, { childList: true });
    });
  }

  function buildSearchCard(item) {
    const a = document.createElement('a');
    a.href = item.url;
    a.className = 'b82-reference-card';
    const media = document.createElement('div');
    media.className = 'b82-reference-card__media';
    const img = makeImg(item);
    if (img) media.append(img);
    const body = document.createElement('div');
    body.className = 'b82-reference-card__body';
    const name = document.createElement('h3');
    name.textContent = item.title;
    const ref = document.createElement('p');
    ref.textContent = 'Referencia olfativa: ' + item.reference;
    const price = document.createElement('strong');
    price.textContent = item.price;
    body.append(name, ref, price);
    const cta = document.createElement('span');
    cta.className = 'b82-reference-card__cta';
    cta.textContent = item.available ? 'Ver perfume →' : 'Ver disponibilidad →';
    body.append(cta);
    a.append(media, body);
    return a;
  }

  function initSearchPage() {
    const panel = document.getElementById('b82-reference-search-results');
    if (!panel) return;
    const term = new URLSearchParams(window.location.search).get('q') || '';
    const matches = findMatches(term);
    if (!matches.length) return;
    const originalResultLinks = new Set(
      Array.from(document.querySelectorAll('#ProductGridContainer a[href*="/products/"]'))
        .map(a => matchKey(a.getAttribute('href')))
    );
    const additional = matches.filter(x => !originalResultLinks.has(matchKey(x.url)));
    if (!additional.length) return;
    const heading = document.createElement('h2');
    heading.textContent = 'Perfumes relacionados con «' + term + '»';
    const help = document.createElement('p');
    help.textContent = 'Coincidencias por nombre, referencia olfativa o estilo de fragancia.';
    const cards = document.createElement('div');
    cards.className = 'b82-reference-card-grid';
    additional.forEach(item => cards.append(buildSearchCard(item)));
    panel.append(heading, help, cards);
    panel.hidden = false;
    const wrapper = document.querySelector('.template-search');
    if (wrapper) {
      wrapper.classList.remove('template-search--empty');
      wrapper.classList.add('b82-has-reference-results');
    }
    // Evitar mensaje contradictorio «No se encontraron productos».
    const nativeCount = Number(panel.dataset.nativeCount) || 0;
    if (!nativeCount) {
      document.querySelectorAll('.template-search__header p[role="status"]').forEach(x => x.hidden = true);
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.hidden = true;
      const facets = document.querySelector('.facets-container');
      if (facets) facets.hidden = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initPredictive(); initSearchPage(); });
  } else {
    initPredictive();
    initSearchPage();
  }
})();
